// containers/LoanListContainer.js

import { useEffect, useState } from 'react';
import { getAllLoans } from '../../TWGLogin/axiosConfig';
import ManagerLoanList from '../pages/LoanList';

const LoanListContainer = () => {
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getAllLoans()
      .then((res) => {
        setLoans(res.data.data?.loans || []);
      })
      .catch((err) => {
        console.error(err);
        setError('Failed to load loans');
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <ManagerLoanList
      loans={loans}
      loading={loading}
      error={error}
    />
  );
};

export default LoanListContainer;